"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getTags = void 0;
const shogi_js_1 = require("shogi.js");
const turn_readable = (p) => {
    switch (p) {
        case "P":
        case "+P":
        case "L":
        case "+L":
        case "N":
        case "+N":
        case "S":
        case "+S":
        case "G":
        case "+G":
        case "B":
        case "+B":
        case "R":
        case "+R":
        case "K":
        case "+K":
            return "☗";
        case "p":
        case "+p":
        case "l":
        case "+l":
        case "n":
        case "+n":
        case "s":
        case "+s":
        case "g":
        case "+g":
        case "b":
        case "+b":
        case "r":
        case "+r":
        case "k":
        case "+k":
            return "☖";
        default:
            return "";
    }
};
const piece_readable = (p) => {
    switch (p.toLowerCase()) {
        case "p":
            return "歩";
        case "+p":
            return "と";
        case "l":
            return "香";
        case "+l":
            return "成香";
        case "n":
            return "桂";
        case "+n":
            return "成桂";
        case "s":
            return "銀";
        case "+s":
            return "成銀";
        case "g":
            return "金";
        case "+g":
            return "成金";
        case "b":
            return "角";
        case "+b":
            return "馬";
        case "r":
            return "飛";
        case "+r":
            return "龍";
        case "k":
            return "玉";
        case "+k":
            return "成玉";
        case "_":
            return "(空)";
        case "+_":
            return "(成空)";
        default:
            return "";
    }
};
const sq_readable = (sq) => `${{
    "1": "１",
    "2": "２",
    "3": "３",
    "4": "４",
    "5": "５",
    "6": "６",
    "7": "７",
    "8": "８",
    "9": "９",
}[sq.substring(0, 1)]}${{
    a: "一",
    b: "二",
    c: "三",
    d: "四",
    e: "五",
    f: "六",
    g: "七",
    h: "八",
    i: "九",
}[sq.substring(1, 2)]}`;
// eslint-disable-next-line @typescript-eslint/no-var-requires
const castle = require("./castle.json")
    .reduce((r, e) => {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _o, _p, _q, _r, _s;
    if (e.noturn) {
        r.push({
            id: e.id,
            name: {
                ja_JP: e.name.ja_JP,
                en_US: e.name.en_US || e.id,
            },
            pieces: e.pieces,
            moves: e.moves,
            capture: e.capture,
            hand: e.hand,
            hand_exclude: e.hand_exclude,
            special: e.special,
            tags_required: e.tags_required,
            tags_exclude: e.tags_exclude,
            tags_disable: e.tags_disable,
            tesuu_min: e.tesuu_min,
            tesuu_max: e.tesuu_max,
            hide: e.hide,
        });
    }
    else {
        delete e.noturn;
        const revPiece = (p) => p.replace(/[A-Za-z]/, (c) => String.fromCharCode(c.charCodeAt(0) ^ 32));
        const revSquare = (sq) => sq
            .replace(/[1-9]/, (c) => String.fromCharCode(106 - c.charCodeAt(0)))
            .replace(/[a-i]/, (c) => String.fromCharCode(202 - c.charCodeAt(0)));
        r.push({
            id: `SENTE_${e.id}`,
            name: {
                ja_JP: `先手${e.name.ja_JP}`,
                en_US: `SENTE_${e.name.en_US || e.id}`,
            },
            pieces: (_a = e.pieces) === null || _a === void 0 ? void 0 : _a.map((p) => p),
            moves: (_b = e.moves) === null || _b === void 0 ? void 0 : _b.map((m) => m),
            capture: (_c = e.capture) === null || _c === void 0 ? void 0 : _c.map((p) => p),
            hand: (_d = e.hand) === null || _d === void 0 ? void 0 : _d.map((p) => p),
            hand_exclude: (_e = e.hand_exclude) === null || _e === void 0 ? void 0 : _e.map((p) => p),
            special: e.special,
            tags_required: (_f = e.tags_required) === null || _f === void 0 ? void 0 : _f.map((t) => `SENTE_${t}`),
            tags_exclude: (_g = e.tags_exclude) === null || _g === void 0 ? void 0 : _g.map((t) => `SENTE_${t}`),
            tags_disable: (_h = e.tags_disable) === null || _h === void 0 ? void 0 : _h.map((t) => `SENTE_${t}`),
            tesuu_min: e.tesuu_min,
            tesuu_max: e.tesuu_max,
            hide: e.hide,
        });
        r.push({
            id: `GOTE_${e.id}`,
            name: {
                ja_JP: `後手${e.name.ja_JP}`,
                en_US: `GOTE_${e.name.en_US || e.id}`,
            },
            pieces: (_j = e.pieces) === null || _j === void 0 ? void 0 : _j.map((p) => {
                const _m = p.match(/^(\+?[_PLNSGBRKplnsgbrk])\*([1-9][a-i])$/);
                return _m ? `${revPiece(_m[1])}*${revSquare(_m[2])}` : "";
            }),
            hand: (_k = e.hand) === null || _k === void 0 ? void 0 : _k.map((p) => {
                const _m = p.match(/^(\+?[PLNSGBRKplnsgbrk])$/);
                return _m ? `${revPiece(_m[1])}` : "";
            }),
            hand_exclude: (_l = e.hand_exclude) === null || _l === void 0 ? void 0 : _l.map((p) => {
                const _m = p.match(/^(\+?[PLNSGBRKplnsgbrk])$/);
                return _m ? `${revPiece(_m[1])}` : "";
            }),
            special: e.special,
            moves: (_o = e.moves) === null || _o === void 0 ? void 0 : _o.map((m) => {
                const _m = m.match(/^(\+?[PLNSGBRKplnsgbrk])\*([1-9][a-i])([1-9][a-i])(\+?)$/);
                return _m
                    ? `${revPiece(_m[1])}*${revSquare(_m[2])}${revSquare(_m[3])}${_m[4]}`
                    : "";
            }),
            capture: (_p = e.capture) === null || _p === void 0 ? void 0 : _p.map((p) => revPiece(p)),
            tags_required: (_q = e.tags_required) === null || _q === void 0 ? void 0 : _q.map((t) => `GOTE_${t}`),
            tags_exclude: (_r = e.tags_exclude) === null || _r === void 0 ? void 0 : _r.map((t) => `GOTE_${t}`),
            tags_disable: (_s = e.tags_disable) === null || _s === void 0 ? void 0 : _s.map((t) => `GOTE_${t}`),
            tesuu_min: e.tesuu_min,
            tesuu_max: e.tesuu_max,
            hide: e.hide,
        });
    }
    return r;
}, [])
    .map((e) => {
    var _a, _b, _c, _d, _e;
    return Object.assign({}, e, {
        pieces_readable: (_a = e.pieces) === null || _a === void 0 ? void 0 : _a.map((p) => {
            const _m = p.match(/^(\+?[_PLNSGBRKplnsgbrk])\*([1-9][a-i])$/);
            return _m
                ? `${turn_readable(_m[1])}${sq_readable(_m[2])}${piece_readable(_m[1])}`
                : "";
        }),
        hand_readable: (_b = e.hand) === null || _b === void 0 ? void 0 : _b.map((p) => {
            const _m = p.match(/^(\+?[PLNSGBRKplnsgbrk])$/);
            return _m
                ? `${turn_readable(_m[1])}${piece_readable(_m[1])}`
                : "";
        }),
        hand_exclude_readable: (_c = e.hand_exclude) === null || _c === void 0 ? void 0 : _c.map((p) => {
            const _m = p.match(/^(\+?[PLNSGBRKplnsgbrk])$/);
            return _m
                ? `${turn_readable(_m[1])}${piece_readable(_m[1])}`
                : "";
        }),
        moves_readable: (_d = e.moves) === null || _d === void 0 ? void 0 : _d.map((m) => {
            const _m = m.match(/^(\+?[PLNSGBRKplnsgbrk])\*([1-9][a-i])([1-9][a-i])(\+?)$/);
            return _m
                ? `${turn_readable(_m[1])}${sq_readable(_m[2])}${piece_readable(_m[1])}→${turn_readable(_m[1])}${sq_readable(_m[3])}${piece_readable(`${_m[4]}${_m[1]}`)}`
                : "";
        }),
        capture_readable: (_e = e.capture) === null || _e === void 0 ? void 0 : _e.map((p) => `${turn_readable(p)}${piece_readable(p)}`),
    });
});
exports.getTags = (player) => player.kifu.moves.reduce((p, v, i) => {
    var _a;
    player.goto(i);
    castle.forEach((c) => {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j;
        if (!(c.tesuu_max < i ||
            (c.tesuu_min && c.tesuu_min > i) ||
            p.some((t) => t.id === c.id) ||
            (c.tags_required &&
                c.tags_required.some((te) => !p.some((_te) => _te.id === te))) || ((_a = c.pieces) === null || _a === void 0 ? void 0 : _a.some((p) => {
            const pm = p.match(/^(\+?[_PLNSGBRKplnsgbrk])\*([1-9])([a-i])$/);
            if (!pm) {
                return false;
            }
            const bp = player.shogi.get(pm[2].charCodeAt(0) - 48, pm[3].charCodeAt(0) - 96);
            if (!bp) {
                return pm[1] !== "_";
            }
            return pm[1] !== bp.toSFENString();
        })) || ((_b = c.hand) === null || _b === void 0 ? void 0 : _b.some((p) => player.shogi.hands[shogi_js_1.Piece.fromSFENString(p).color].every((v) => p !== v.toSFENString()))) || ((_c = c.hand_exclude) === null || _c === void 0 ? void 0 : _c.some((p) => player.shogi.hands[shogi_js_1.Piece.fromSFENString(p).color].some((v) => p === v.toSFENString()))) ||
            (c.special && v.special !== c.special) ||
            (((_d = c.moves) === null || _d === void 0 ? void 0 : _d.length) && ((_e = c.moves) === null || _e === void 0 ? void 0 : _e.every((m) => {
                var _a, _b, _c, _d;
                const pm = m.match(/(\+?[PLNSGBRKplnsgbrk])\*([1-9])([a-i])([1-9])([a-i])(\+?)/);
                if (!pm || !v.move) {
                    return true;
                }
                return (v.move.piece !==
                    shogi_js_1.Piece.fromSFENString(pm[1])
                        .toCSAString()
                        .substring(1) ||
                    ((_a = v.move.from) === null || _a === void 0 ? void 0 : _a.x) !== pm[2].charCodeAt(0) - 48 ||
                    ((_b = v.move.from) === null || _b === void 0 ? void 0 : _b.y) !== pm[3].charCodeAt(0) - 96 ||
                    ((_c = v.move.to) === null || _c === void 0 ? void 0 : _c.x) !== pm[4].charCodeAt(0) - 48 ||
                    ((_d = v.move.to) === null || _d === void 0 ? void 0 : _d.y) !== pm[5].charCodeAt(0) - 96 ||
                    !!v.move.promote !== (pm[6] === "+"));
            }))) ||
            (((_f = c.capture) === null || _f === void 0 ? void 0 : _f.length) && ((_g = c.capture) === null || _g === void 0 ? void 0 : _g.every((p) => {
                var _a;
                return ((_a = v.move) === null || _a === void 0 ? void 0 : _a.capture) !==
                    shogi_js_1.Piece.fromSFENString(p)
                        .toCSAString()
                        .substring(1);
            }))))) {
            (_h = c.tags_disable) === null || _h === void 0 ? void 0 : _h.forEach((t) => {
                p.filter((te) => te.id === t).forEach((te) => {
                    te.hide = true;
                });
            });
            const tag = Object.assign({}, c, {
                tesuu: i,
                hide: c.hide || ((_j = c.tags_exclude) === null || _j === void 0 ? void 0 : _j.some((te) => p.some((_te) => _te.id === te))) ||
                    undefined,
            });
            for (const [key, value] of Object.entries(tag)) {
                if (value === null || value === undefined) {
                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    delete tag[key];
                }
            }
            p.push(tag);
        }
    });
    (_a = v.comments) === null || _a === void 0 ? void 0 : _a.forEach((comment) => {
        const _ma = comment.match(/^summary:([0-9A-Za-z_. -]+):([0-9A-Za-z_.-]+) (lose|draw|win):([0-9A-Za-z_.-]+) (lose|draw|win)$/);
        if (!_ma) {
            return;
        }
        // MAX_MOVES
        if (_ma[1] === "max_moves") {
            p.push({
                id: "MAX_MOVES",
                name: {
                    ja_JP: "最大手数",
                    en_US: "MAX_MOVES",
                },
                tesuu_max: 1e9,
                tesuu: i,
            });
        }
        // WIN / LOSE / DRAW
        if (_ma[3] === "draw" && _ma[5] === "draw") {
            p.push({
                id: "DRAW",
                name: {
                    ja_JP: "引き分け",
                    en_US: "DRAW",
                },
                tesuu_max: 1e9,
                tesuu: i,
            });
        }
        else if (_ma[3] === "win" && _ma[5] === "lose") {
            p.push({
                id: "SENTE_WIN",
                name: {
                    ja_JP: "先手勝ち",
                    en_US: "SENTE_WIN",
                },
                tesuu_max: 1e9,
                tesuu: i,
            });
        }
        else if (_ma[3] === "lose" && _ma[5] === "win") {
            p.push({
                id: "GOTE_WIN",
                name: {
                    ja_JP: "後手勝ち",
                    en_US: "GOTE_WIN",
                },
                tesuu_max: 1e9,
                tesuu: i,
            });
        }
    });
    return p;
}, []);
